// Traduz o código de erro que `createAgencySaleDetail` devolve numa frase que a
// revenda entende, e que diz o que fazer.
//
// Antes a tela ignorava o retorno por completo: disparava a venda sem `await`,
// fechava o modal e limpava o formulário na hora. A revenda via "sucesso" mesmo
// quando a API recusava — e uma recarga que nunca aconteceu parecia ter dado
// certo. Os códigos abaixo são os 9 que a mutation realmente devolve, conferidos
// um a um contra a API de dev em 17/09/2026.
export const SALE_ERROR_MESSAGES: Record<string, string> = {
  agency_not_balance_coins:
    "Saldo de moedas insuficiente para esta venda. Confira seu estoque e tente um valor menor.",
  invalid_coins:
    "Quantidade inválida. Informe um número inteiro de moedas, maior que zero.",
  user_not_found:
    "Nenhum usuário encontrado com esse ID. Confira o número e tente de novo.",
  agency_not_found:
    "Nenhum agente encontrado com esse ID. Confira o número e tente de novo.",
  not_allowed:
    "Você não tem permissão para vender por esta revenda. Saia e entre de novo na sua conta.",
  invalid_token: "Sua sessão expirou. Entre novamente para continuar vendendo.",
  invalid_ids: "Os dados da venda vieram incompletos. Recarregue a página e tente de novo.",
  "error on createAgencySaleDetail":
    "Não foi possível concluir a venda. Nada foi cobrado do seu estoque — tente novamente.",
};

// Traduz o que `reverseAgencySaleDetail` devolve. O ponto mais importante pra
// quem opera: quando o estorno é recusado, NADA foi movido — nem o saldo do
// comprador, nem o estoque, nem os ledgers. A mutation escreve tudo numa
// instrução só, então recusa significa estado intacto.
export const REVERSE_ERROR_MESSAGES: Record<string, string> = {
  dest_not_balance_coins:
    "O cliente não tem mais as moedas desta venda na carteira. O estorno só é possível com o valor completo disponível — nada foi alterado.",
  already_reversed: "Esta venda já foi estornada.",
  sale_not_found: "Venda não encontrada. Atualize o histórico e tente de novo.",
  not_allowed:
    "Você não tem permissão para estornar esta venda. Saia e entre de novo na sua conta.",
  invalid_token: "Sua sessão expirou. Entre novamente para continuar.",
  invalid_sale_id: "Os dados da venda vieram incompletos. Recarregue a página e tente de novo.",
  invalid_coins: "O valor desta venda é inválido e não pode ser estornado automaticamente.",
  // Venda antiga (anterior a 21/09/2026) cujo destino tem o mesmo ID como
  // usuário E como agência — a linha não guarda qual dos dois era, e chutar
  // debitaria a carteira errada.
  dest_ambiguous:
    "Esta venda é antiga e não registra se o destino era um cliente ou uma agência. O estorno precisa ser feito pelo suporte.",
  dest_not_found: "O destino desta venda não existe mais. O estorno precisa ser feito pelo suporte.",
  "error on reverseAgencySaleDetail":
    "Não foi possível estornar. Nada foi alterado — tente novamente.",
};

export const reverseErrorMessage = (code?: string | null): string => {
  if (code && REVERSE_ERROR_MESSAGES[code]) return REVERSE_ERROR_MESSAGES[code];
  return "Não foi possível estornar. Nada foi alterado — verifique sua conexão e tente novamente.";
};

// Fallback: erro desconhecido (rede caiu, gateway fora, código novo). A frase
// deixa claro o mais importante pra quem vende — o estoque NÃO foi debitado,
// porque a venda só grava se o dinheiro andar junto, na mesma instrução.
export const saleErrorMessage = (code?: string | null): string => {
  if (code && SALE_ERROR_MESSAGES[code]) return SALE_ERROR_MESSAGES[code];
  return "Não foi possível concluir a venda. Seu estoque não foi debitado — verifique sua conexão e tente novamente.";
};
